var _module = require('../../module');

require('../../../services/lr-touch');
require('../../../services/mortgage-calculator-store');
require('../../../filters');

_module.component('priceslider', {
    bindings: {
        min: '<',
        max: '<',
        totalHomes: '@',
        onGotoResults: '&',
        onSelect: '&',
        onUpdate: '&'
    },
    controllerAs: 'priceslider',
    controller: [
        '$log',
        '$scope',
        '$mortgageCalculatorStore',

        function pricesliderCtrl($log, $scope, $mortgageCalculatorStore) {
            var _this = this;

            this.showMonthlyPayment = false;
            this.price = 1000000;
            this.percent = Math.round(this.price / parseInt(this.max) * 100);
            this.sliderOptions = {
                floor: parseInt(this.min),
                ceil: parseInt(this.max)
            };

            // $watch
            $scope.$watch(function () { return $mortgageCalculatorStore.loading; }, function (value) {
                if(!value && $mortgageCalculatorStore.interest_rates['30']) {
                    _this.showMonthlyPayment = true;
                }
            });

            // Functions
            this.onDrag = function onDrag(e) {
                var value = Math.round(e.percentX * 100) / 100 * parseInt(_this.max);

                if(value !== _this.price) {
                    _this.price = value;
                    _this.percent = e.percentX * 100;
                    _this.onUpdate({ $value: value });
                }
            };

            this.next = function next() {
                var value = _this.price === parseInt(this.max) ? null : _this.price;

                _this.onSelect({ $value: value });
            };

            this.calculateMonthlyPayment = function calculateMonthlyPayment() {
                var principal = _this.price * 0.8;
                var interest = $mortgageCalculatorStore.interest_rates['30'];
                var numPayments = 30 * 12;

                return $mortgageCalculatorStore.calculatePrincipalAndInterestPayment(principal, interest, numPayments);
            };
        }
    ],
    template: require('./index.html')
});
